// Из Калуги «Керамзит в мешках» отгружается только полной фурой — 1 500 мешков в машине
// (запрос менеджера, 07.09.2026). Поэтому в расчёт идёт количество, поднятое до кратного
// фуре: клиент платит за полную машину, даже если заказал меньше.
//
// Считаем мешки, а не кубы: объём мешка зависит от фракции (0,011–0,0325 м3 в
// номенклатуре), и вместимость фуры одним числом в м3 под все фракции не задать.
//
// Число рейсов по этому же правилу считает сервер (routes/deliveryKeramzitCalculator.js,
// KALUGA_MESHKI_BAGS_PER_TRUCK) — здесь только количество товара, от которого идёт сумма
// за товар.
//
// Биг-бэги из Калуги — то же самое, но в кубах: фура 72 м3 (правка менеджера от
// 14.09.2026). Заказ меньше KALUGA_BIGBAG_MIN_ORDER_VOLUME (70 м3) Калуга не берёт вовсе
// — это решает сервер, сюда такой заказ просто не доходит; всё, что доходит, поднимается
// до кратного 72 м3.
//
// Правило узкое: производство «Калуга» (в справочнике оно одно, регион СПБ) и категории
// «Керамзит в мешках»/«Керамзит в Биг-Бэгах». Ни другие производства, ни навал, ни
// остальная нерудка его не касаются.

export const KALUGA_MESHKI_BAGS_PER_TRUCK = 1500;
export const KALUGA_BIGBAG_M3_PER_TRUCK = 72;

const KALUGA_PRODUCTION = "калуга";
const MESHKI_CATEGORY = "керамзит в мешках";
const BIGBAG_CATEGORY = "керамзит в биг-бэгах";

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/\s+/g, " ");

export const isKalugaKeramzitMeshki = (production, category) =>
  normalize(production) === KALUGA_PRODUCTION && normalize(category) === MESHKI_CATEGORY;

export const roundKalugaMeshkiQuantity = (quantity, production, category) => {
  const bags = Number(quantity);
  if (!isKalugaKeramzitMeshki(production, category) || !Number.isFinite(bags) || bags <= 0) {
    return quantity;
  }

  return Math.ceil(bags / KALUGA_MESHKI_BAGS_PER_TRUCK) * KALUGA_MESHKI_BAGS_PER_TRUCK;
};

export const isKalugaKeramzitBigbag = (production, category) =>
  normalize(production) === KALUGA_PRODUCTION && normalize(category) === BIGBAG_CATEGORY;

// Биг-бэги считаются в кубах (ед. изм. номенклатуры — м3), поэтому здесь тот же подъём
// до полной машины, но кратно 72 м3, а не 1 500 мешкам.
export const roundKalugaBigbagVolume = (quantity, production, category) => {
  const volume = Number(quantity);
  if (!isKalugaKeramzitBigbag(production, category) || !Number.isFinite(volume) || volume <= 0) {
    return quantity;
  }

  return Math.ceil(volume / KALUGA_BIGBAG_M3_PER_TRUCK) * KALUGA_BIGBAG_M3_PER_TRUCK;
};

// Единая точка входа для таблицы сравнения производств и КП: правило одно («Калуга везёт
// только полными машинами»), а единица измерения у категорий разная.
export const roundKalugaTruckQuantity = (quantity, production, category) =>
  roundKalugaBigbagVolume(
    roundKalugaMeshkiQuantity(quantity, production, category),
    production,
    category
  );
